export default "__VITE_ASSET__f8b91cf9__"